/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Light_Loud_Falcon_ActInputs */

const en_light_loud_falcon_act = /** @type {(inputs: Light_Loud_Falcon_ActInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected File`)
};

const de_light_loud_falcon_act = /** @type {(inputs: Light_Loud_Falcon_ActInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Datei`)
};

/**
* | output |
* | --- |
* | "Selected File" |
*
* @param {Light_Loud_Falcon_ActInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const light_loud_falcon_act = /** @type {((inputs?: Light_Loud_Falcon_ActInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Light_Loud_Falcon_ActInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_light_loud_falcon_act(inputs)
	return de_light_loud_falcon_act(inputs)
});